import { StorageFile } from "../../../types/StorageFile";
import { array, boolean, date, enumKeys, int, isbn, nullable, number, object, string } from "../../../types/_types";

import { ImprintRef } from "../../imprints/types/ImprintRef";
import { SerieRef } from "../../series/types/Serie";

import epubVersions from "../constants/epubVersions";

import { ArticleContributor } from "./ArticleContributor";
import { ArticlePrice } from "./ArticlePrice";

const epubVersion = enumKeys(epubVersions);

export const ArticleMetaData = object({
	abridged: boolean().default(false),
	accessibility: array(string()),
	additionalLanguages: array(string()),
	announcementDate: nullable(date()),
	bisacCodes: array(string()),
	bokgruppe: nullable(string()),
	contributors: array(ArticleContributor),
	countries: array(string()),
	cover: nullable(StorageFile),
	duration: number().default(0),
	epubVersion: nullable(epubVersion),
	hazardsOrWarnings: array(string()),
	imprint: nullable(ImprintRef),
	isbn: isbn().default(""),
	language: string().default(null),
	name: string(1).default(""),
	originalLanguage: nullable(string(2)),
	originalName: string().default(""),
	pages: nullable(int()),
	prices: array(ArticlePrice),
	releaseDate: nullable(date()),
	serie: nullable(SerieRef),
	serieNumber: nullable(int().min(1)),
	subtitle: string().default(""),
	synopsis: string().default(""),
	tags: array(string()),
	takedownDate: nullable(date()),
	themaCodes: array(string()),
	mainThemaCode: nullable(string()),
});
